import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    cell: {
      borderBottom: "none",
    },
    link: {
      textDecoration: "underline",
    },
    button: {
      margin: [40, 0],
    },
  }),
  { name: "Receipt" },
);
